<template>
    <!-- Aviso das telas da area do credor/procurador para quem nao entrou na conta -->
    <div class="login-required">
        <span class="login-required__icon"><v-icon small color="#7e55ab">mdi-lock-outline</v-icon></span>
        <span class="login-required__text">Por favor, entre na sua conta para ter acesso a esta área.</span>
        <v-btn depressed color="primary" class="login-required__btn" @click="openLogin">Entrar</v-btn>
    </div>
</template>

<script>
import { eventHub } from "@/main";

export default {
    name: "LoginRequiredNotice",

    methods: {
        // Mesmo dialogo de acesso do menu do site.
        openLogin() {
            eventHub.$emit("DIALOG-ACCESS", true);
        },
    },
};
</script>

<style scoped>
.login-required {
    display: flex;
    align-items: center;
    gap: 12px 14px;
    flex-wrap: wrap;
    padding: 16px 20px;
    border-radius: 14px;
    background: rgba(120, 119, 229, 0.09);
    color: #2a1a40;
    font-size: 14px;
    font-weight: 600;
    margin: 8px 0 40px;
}

.login-required__icon {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    flex-shrink: 0;
}

.login-required__text {
    flex: 1 1 260px;
}

.login-required__btn {
    height: 38px !important;
    padding: 0 20px !important;
    border-radius: 10px;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 600;
}
</style>
